/**
 * 全局控制 h5 内容的 iframe弹窗
 * */
import React, { useEffect, useRef } from 'react';
import IframeModal from './IframModal';
import { connect } from 'react-redux';

const GlobalIframeModal = (props) => {
  const { base } = props;
  const iframeElement = useRef();

  useEffect(() => {
    if (base.globalIframe != null && !!iframeElement?.current) {
      if (base?.globalIframe?.visible) {
        const params = base?.globalIframe?.params || {};
        iframeElement.current.showModal(base?.globalIframe?.url, params);
      } else {
        iframeElement.current.hideModal();
      }
    }
  }, [base.globalIframe]);

  return <IframeModal wrappedComponentRef={iframeElement} />;
};

export default connect((store) => ({ base: store }))(GlobalIframeModal);
